import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, unref as _unref } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-controls" }
const _hoisted_4 = { class: "button-group" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "modal-main" }
const _hoisted_8 = {
  key: 0,
  class: "container"
}
const _hoisted_9 = {
  key: 2,
  class: "container"
}
const _hoisted_10 = { class: "modal-footer" }

import { onMounted, onUnmounted, ref, computed, watchEffect } from 'vue';
	import axios from 'axios';
	import functions from '@/use/functions';
	import Spinner from '@/components/shared/Spinner.vue';
	import { DocumentMagnifyingGlassIcon } from '@heroicons/vue/24/solid';
	import { BorrowerCreditReportModel } from '@/models/loans';

	
export default /*@__PURE__*/_defineComponent({
  __name: 'CreditReportViewerModal',
  props: {
    annualReviewId: {},
    creditPullTypeId: {},
    onClose: { type: Function }
  },
  setup(__props: any) {

	const props = __props;

	const isLoading = ref<boolean>(false);
	const creditReports = ref<BorrowerCreditReportModel[]>();
	const selectedBorrowerTypeId = ref<number>(1);
	const selectedCreditReportId = ref<number | null>();
	const rawCreditReport = ref<string>('');

	const handleOverlayClick = (event: MouseEvent) => {
		const target = event.target as HTMLElement;

		if (target.classList.contains('modal-overlay')) {
			props.onClose();
		}
	};

	const selectBorrowerTypeId = (borrowerTypeId: number) => (selectedBorrowerTypeId.value = borrowerTypeId);

	const borrowerButtonClass = (borrowerTypeId: number) =>
		selectedBorrowerTypeId.value === borrowerTypeId ? '' : 'secondary';

	const creditReportOptions = computed(() => {
		if (!creditReports.value) {
			return [];
		}

		return creditReports.value.filter((r) => r.borrowerTypeId === selectedBorrowerTypeId.value);
	});

	const emptyStateMessage = computed(() =>
		creditReportOptions.value.length > 0 ? 'No credit report selected' : 'No credit reports found'
	);

	const fetchCreditReportsAsync = async () => {
		isLoading.value = true;

		try {
			const queryParams = {
				creditPullTypeId: props.creditPullTypeId
			};

			const response = await axios.get<BorrowerCreditReportModel[]>(
				`/api/annualreview/${props.annualReviewId}/credit-reports`,
				{ params: queryParams }
			);

			creditReports.value = response.data;
		} catch (error) {
			functions.openModal({
				title: 'Oops!',
				description: `There was an issue getting the credit reports. Please try again later.`
			});
		} finally {
			isLoading.value = false;
		}
	};

	const fetchRawCreditReportAsync = async (creditReportId: number) => {
		if (!creditReportId || !creditReports.value) {
			return;
		}

		const rawCreditReportId = creditReports.value.find((r) => r.id === creditReportId)?.rawCreditReportId;

		isLoading.value = true;

		try {
			const response = await axios(`/api/annualreview/${creditReportId}/raw-credit-report/${rawCreditReportId}`);

			rawCreditReport.value = response.data;
		} catch (error) {
			functions.openModal({
				title: 'Oops!',
				description: `There was an issue getting the raw credit report. Please try again later.`
			});

			rawCreditReport.value = '';
		} finally {
			isLoading.value = false;
		}
	};

	watchEffect(() => {
		const invalidReportId = !creditReportOptions.value.some((report) => report.id === selectedCreditReportId.value);

		if (!selectedCreditReportId.value || invalidReportId) {
			selectedCreditReportId.value = creditReportOptions.value[0]?.id ?? null;
		}

		if (selectedCreditReportId.value) {
			fetchRawCreditReportAsync(selectedCreditReportId.value);
		}
	});

	onMounted(async () => {
		document.body.style.overflow = 'hidden';

		await fetchCreditReportsAsync();
	});

	onUnmounted(() => {
		document.body.style.overflow = '';
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal-overlay",
    onClick: handleOverlayClick
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("h3", null, "View Credit Report", -1)),
        _createElementVNode("span", {
          class: "close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.onClose && __props.onClose(...args)))
        }, "×")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (selectBorrowerTypeId(1))),
            class: _normalizeClass(borrowerButtonClass(1))
          }, "Primary Borrower", 2),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (selectBorrowerTypeId(2))),
            class: _normalizeClass(borrowerButtonClass(2))
          }, "Co-Borrower", 2)
        ]),
        (creditReportOptions.value.length > 0)
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 0,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedCreditReportId).value = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(creditReportOptions.value, (report) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: report.id,
                  value: report.id
                }, _toDisplayString(report.name), 9, _hoisted_5))
              }), 128))
            ], 512)), [
              [_vModelSelect, selectedCreditReportId.value]
            ])
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(Spinner)
              ]))
            : (selectedCreditReportId.value)
              ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                  key: 1,
                  readonly: "",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rawCreditReport).value = $event))
                }, null, 512)), [
                  [_vModelText, rawCreditReport.value]
                ])
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_unref(DocumentMagnifyingGlassIcon), { class: "empty-icon" }),
                  _createElementVNode("p", null, _toDisplayString(emptyStateMessage.value), 1)
                ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (__props.onClose && __props.onClose(...args)))
        }, "Close")
      ])
    ])
  ]))
}
}

})